var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BRadioInputValidation',{attrs:{"vid":"status","name":"status","buttons":"","button-variant":"outline-primary","options":_vm.offerStatusOptions,"size":"sm"},on:{"change":_vm.onClick},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }